<template>
  <categories-show />
</template>

<script>
import CategoriesShow from '../../components/categories/Show'

export default {
  name: 'CategoriesPageShow',
  components: { CategoriesShow }
}
</script>

<style scoped>
  /* Always export scoped styles to not break the app */
</style>
